export enum ExpensesColumnsEnum {
  Date = 'date',
  Name = 'description',
  Description = 'description2',
  Number = 'number',
  Quantity = 'quantity',
  Unit = 'unit',
  Price = 'price',
  Total = 'total',
  Note = 'note',
  OrderNumber = 'orderNumber',
  OrderName = 'orderName',
  OrderDescription = 'orderDescription',
  FirstName = 'firstName',
  LastName = 'lastName',
  PersonalNR = 'personalNumber',
}
